import { Controller } from "@hotwired/stimulus";
import CheckboxSelectAll from "stimulus-checkbox-select-all"

export default CheckboxSelectAll
